export const RESOLUTIONS = {
	MIN: 928,
	LOW: 930,
	MED: 1344,
	HIGH: 2240,
};

export const BREAKPOINT_COLCOUNT_MAP = {
	[RESOLUTIONS.LOW]: 96,
	[RESOLUTIONS.MED]: 144,

	[RESOLUTIONS.HIGH]: 240,
};
